
import React, { useState } from 'react'

import './UserItem.scss'
import UserAvatar from '@/Components/UserAvatar/UserAvatar'
import useTranslation from '@/Hooks/UseTranslation'
import { useAuth } from '@/Hooks/UseAuth'
import { useTeams } from '@/Hooks/UseTeam'
import Spinner from '@/Components/SvgImages/Spinner/Spinner'

interface Props {
  user: any
}

const UserItem = (props: Props) => {

  const { user } = props

  const { t } = useTranslation()

  const { isMe } = useAuth()

  const { inviteUser, addMe } = useTeams()

  const [ isInviting, setIsInviting ] = useState(false)
  const [ isInvited, setIsInvited ] = useState(user.hasPendingInvite)
  const [ isAdded, setIsAdded ] = useState(user.isInTeam)

  const handleAddUser = async (user: any) => {

    if (isInviting || isInvited || isAdded) return

    if (isMe(user._id)) {

      await addMe()
    } else {

      setIsInviting(true)
      await inviteUser(user)

      setIsInviting(false)
      setIsInvited(true)
    }

    setIsAdded(true)
  }

  return (
    <div className="user-item"
      onClick={() => handleAddUser(user)}
    >
      <UserAvatar user={props.user} />
      <div className="user-texts">
        <div className="user-name">
          {props.user.name} {props.user.surname}
        </div>
        <div className="user-email">
          {props.user.email}
        </div>
      </div>
      <div>
        {isAdded && t('TEAMMEMBER_SELECTOR:UserListUserAlreadyInTeam')}
        {!isAdded && isInvited && t('TEAMMEMBER_SELECTOR:UserListUserIsAlreadyInvited')}
        {isInviting && (
          <Spinner height={24} width={24} />
        )}
      </div>
    </div>
  )
}

export default UserItem
